import styled from "styled-components";

export const Wrapper = styled.div` 
    .filters{
.ant-select-selector, .ant-input-number-outlined {
    background: #fff !important;
    color: #5E6278 !important;
    min-height: 42px;
}
.ant-input-number .ant-input-number-input{
    padding: 9px 11px;
}
.ant-select-selection-item{
    font-size: 13px !important;
    font-weight: 500;
}
.ant-select-item{
font-size: .95rem !important;
    font-weight: 500;
}
    .ant-select .ant-select-arrow{
        height: 22px;
    }
.ant-select .ant-select-selection-placeholder{
font-size: 13px !important;
    color: #5E6278 !important;
    font-weight: 500;
}
.ant-picker-input input{font-size:13px}
.ant-picker-range {
    //border:1px solid #f00;
}

.ant-select-multiple .ant-select-selection-item-content{
    font-size: 12px;
}
}
`;